// extracted by mini-css-extract-plugin
export default {"tabContainer":"personInfo_tabContainer__sWvNF"};